const openFreshChat = () => {
  window?.fcWidget?.open()
}

const openIntercom = () => {
  window?.Intercom?.('show')
}

export const openSupportChat = () => {
  const enableIntercom = process.env.NEXT_PUBLIC_ENABLE_INTERCOM === 'true'

  if (enableIntercom) {
    openIntercom()
  } else {
    openFreshChat()
  }
}
